module.exports = __webpack_public_path__ + "static/media/collection-bird-09-effect.4ee99620.png";